import { interchangeTransfersMiddleware as interchangeTransferListMiddleware } from "./transfers-middleware";

export const interchangeTransfersMiddleware = [
  interchangeTransferListMiddleware,
];
